<template>
    <div>
        <PageSpinner :onloader="onloader" />
        <cbt-question-generator
            :show.sync="modals.aiGenerator"
            :header="generationHeader"
            :existing-questions="cbtquestionitem"
            @save="saveGeneratedQuestions"
        />
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white">
                Dashboard
            </router-link>
            <router-link to="/school/examination-and-assessment" class="text-white">
                <i class="fa fa-ellipsis-v px-2"></i>Examination and Assessment Management
            </router-link>
            <router-link to="/school/examination-and-assessment/cbt-exams" class="text-white">
                <i class="fa fa-ellipsis-v px-2"></i>CBT Exams
            </router-link>
            <span class="text-white"><i class="fa fa-ellipsis-v px-2"></i>CBT Exam Questions
            </span>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <div class="mb-5 mb-xl-0">
                <card header-classes="bg-transparent">
                    <modal :show.sync="modals.questionModal" modal-classes="modal-dialog-centered modal-lg">
                        <div class="card bg-secondary border-0 mb-0">
                            <div class="card-body">
                                <PageSpinner :onloader="onloader" />
                                <div class="form-horizontal">
                                    <div class="form-group">
                                        <label>Question</label>
                                        <vue-editor id="ExamQuestionval" v-model="ExamQuestionval"
                                            ref="ExamQuestionval">

                                        </vue-editor>

                                    </div>
                                    <div class="form-group">
                                        <label>Answer Details</label>
                                        <vue-editor id="AnswerDetailsval" v-model="AnswerDetailsval"
                                            ref="AnswerDetailsval">

                                        </vue-editor>

                                    </div>

                                    <div class="row">
                                        <div class="col-md-8">
                                            <div class="form-group">
                                                <label>Option A</label>
                                                <vue-editor id="OptionAval" v-model="OptionAval" ref="OptionAval">

                                                </vue-editor>

                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <base-checkbox class="mt-6 mb-4 ml-4" v-model="IsAnswerAval"
                                                   @input="checkcheck('A')">
                                                Is A Answer
                                            </base-checkbox>
                                        </div>
                                        <div class="col-md-8">
                                            <div class="form-group">
                                                <label>Option B</label>
                                                <vue-editor id="OptionBval" v-model="OptionBval" ref="OptionBval">

                                                </vue-editor>

                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <base-checkbox class="mt-6 mb-6 ml-4" v-model="IsAnswerBval"
                                                   @input="checkcheck('B')">
                                                Is B Answer
                                            </base-checkbox>
                                        </div>
                                        <div class="col-md-8">
                                            <div class="form-group">
                                                <label>Option C</label>
                                                <vue-editor id="OptionCval" v-model="OptionCval" ref="OptionCval">

                                                </vue-editor>

                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <base-checkbox class="mt-6 mb-6 ml-4" v-model="IsAnswerCval"
                                                   @input="checkcheck('C')">
                                                Is C Answer
                                            </base-checkbox>
                                        </div>
                                        <div class="col-md-8">
                                            <div class="form-group">
                                                <label>Option D</label>
                                                <vue-editor id="OptionDval" v-model="OptionDval" ref="OptionDval">

                                                </vue-editor>

                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <base-checkbox class="mt-6 mb-6 ml-4" v-model="IsAnswerDval"
                                                   @input="checkcheck('D')">
                                                Is D Answer
                                            </base-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <template slot="footer">
                            <base-button type="default" @click="modals.questionModal = false">Cancel
                            </base-button>
                            <base-button type="success" @click.prevent="submitdata()">Submit
                            </base-button>
                        </template>
                    </modal>
                    <div v-if="cbtheaderitem" class="card bg-success text-muted mb-4">
                        <div class="card-body">
                            <div v-html="cbtheaderitem.questionDetails"></div>
                            <h2 class="text-muted">
                                Access Code :
                                <b>{{ cbtheaderitem.passCode }}</b>
                            </h2>
                            <div class="row">
                                <div class="col-md-6">
                                    <span><b>Session : </b>
                                        {{ cbtheaderitem.schoolSession }}</span>
                                </div>
                                <div class="col-md-6">
                                    <span><b>Term : </b>
                                        {{ cbtheaderitem.schoolTerm }}</span>
                                </div>
                                <div class="col-md-6">
                                    <span><b>Class : </b>
                                        {{ cbtheaderitem.schoolClass }}</span>
                                </div>
                                <div class="col-md-6">
                                    <span><b>Option : </b>
                                        {{ cbtheaderitem.classOption }}</span>
                                </div>
                                <div class="col-md-6">
                                    <span><b>Subject : </b>
                                        {{ cbtheaderitem.subjectName }}</span>
                                </div>
                                <div class="col-md-6">
                                    <span><b>No. to Display : </b>
                                        {{
                                            cbtheaderitem.noofQuestiontoDisplay
                                        }}</span>
                                </div>
                                <div class="col-md-6">
                                    <span><b>Exam Period : </b>
                                        {{ cbtheaderitem.examPeriod }}s</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-inline text-center">
                        <button type="button" @click.prevent="openNew" class="btn btn-default ml-3">
                            <i class="fa fa-plus"></i>Add New
                        </button>
                        <button type="button" @click.prevent="modals.aiGenerator = true" class="btn btn-primary ml-2"
                            :disabled="!cbtheaderitem">
                            <i class="fa fa-wand-magic-sparkles mr-1" aria-hidden="true"></i>Generate with AI
                        </button>
                        <div class="justify-content-end form-inline my-3">
                            <base-input class="input-group-alternative" placeholder="Search here..."
                                addon-left-icon="fa fa-search" v-model="searchval">
                            </base-input>
                        </div>
                    </div>
                    <div class="mt-2">
                        <div class="card bg-secondary my-2" v-for="(item, index) in searchedResultQuery" :key="item.Id">
                            <div class="card-body">
                                <span class="badge badge-warning">
                                    Qtn. {{ index + 1 }}</span>
                                <button v-if="item.syncStatus === 'failed'" class="btn btn-outline-danger btn-sm sync-status" type="button"
                                    :title="syncTitle(item)" @click="retryQuestion(item)">
                                    <i class="fa fa-cloud-upload-alt mr-1" aria-hidden="true"></i><span>Repush</span>
                                </button>
                                <span v-else class="btn btn-outline-primary btn-sm sync-status" :class="`sync-${item.syncStatus}`"
                                    :title="syncTitle(item)">
                                    <i :class="syncIcon(item)" aria-hidden="true"></i>
                                    <span>{{ item.syncStatus }}</span>
                                </span>
                                <div class="my-3" v-html="item.examQuestion"></div>
                                <div class="m-3">
                                    <div class="row">
                                        <div class="col-lg-1">
                                            <span v-if="item.isOptionAAnswer" class="badge badge-success">A</span>
                                            <span v-else class="badge badge-dark">A</span>
                                        </div>

                                        <div class="col-lg-11" v-html="item.optionA"></div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-1">
                                            <span v-if="item.isOptionBAnswer" class="badge badge-success">B</span>
                                            <span v-else class="badge badge-dark">B</span>
                                        </div>
                                        <div class="col-lg-11" v-html="item.optionB"></div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-1">
                                            <span v-if="item.isOptionCAnswer" class="badge badge-success">C</span>
                                            <span v-else class="badge badge-dark">C</span>
                                        </div>
                                        <div class="col-lg-11" v-html="item.optionC"></div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-1">
                                            <span v-if="item.isOptionDAnswer" class="badge badge-success">D</span>
                                            <span v-else class="badge badge-dark">D</span>
                                        </div>
                                        <div class="col-lg-11" v-html="item.optionD"></div>
                                    </div>
                                    <div class="bg-translucent-secondary m-3 p-3">
                                        <b class="text-success">Answer Details</b>
                                        <div v-html="item.answerDetails"></div>
                                    </div>
                                </div>
                                <div class="card-footer text-center">
                                    <button class="btn btn-secondary btn-sm my-2" v-on:click="edititem(item)">
                                        <i class="fa fa-edit"></i> Edit
                                    </button>
                                    <button class="btn btn-secondary btn-sm my-2"
                                        v-on:click="sharequestion(item.questionId)">
                                        <i class="fa fa-share"></i> Share
                                    </button>
                                    <button class="btn btn-secondary btn-sm my-2"
                                        v-on:click="deleteschquestion(item)">
                                        <i class="fa fa-times"></i> Delete
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>

            <!-- End charts-->
        </div>
    </div>
</template>

<script>
import 'quill/dist/quill.snow.css'
import { VueEditor } from 'vue2-quill-editor'
import PageSpinner from "@/components/PageSpinner";
import Alert from "@/mixins/Alert.mixins"
import CheckStaffUser from "@/mixins/CheckStaffUser.mixin"
import { getDB, getCollection } from "@/rxdb";
import { queueRecord, registerSyncQueue, syncCollection } from "@/rxdb/offlineSync";
import { getCurrentUserScope } from "@/rxdb/sessionScope";
import store from "@/store";
import CbtQuestionGenerator from "./components/CbtQuestionGenerator.vue";

function scopedQuestionId(headerId, questionId) {
    return `question:${getCurrentUserScope() || 'unassigned'}:${headerId}:${questionId}`;
}
export default {
    name: "schcbtquestion",
    mixins: [Alert, CheckStaffUser],
    components: {
        PageSpinner,
        VueEditor,
        CbtQuestionGenerator
    },
    data() {
        return {
            accessDetails: null,
            QuestionIdval: 0,
            QuestionHeaderIdval: localStorage.getItem("SchcbtheaderId") || "",
            ExamQuestionval: "",
            AnswerDetailsval: "",
            ImagePathval: "",
            OptionAIdval: 0,
            OptionBIdval: 0,
            OptionCIdval: 0,
            OptionDIdval: 0,
            OptionAval: "",
            IsAnswerAval: false,
            OptionBval: "",
            IsAnswerBval: false,
            OptionCval: "",
            IsAnswerCval: false,
            OptionDval: "",
            IsAnswerDval: false,
            isModified: false,
            cbtquestionitem: [],
            cbtheaderitem: null,
            file: "",
            uploadedimage: "",
            process: "N",
            searchval: "",
            onloader: "none",
            modals: {
                questionModal: false,
                aiGenerator: false
            },
            editorOption: {
                debug: 'info',
                placeholder: 'Type in here',
                readonlly: true,
                theme: 'snow'
            },
        };
    },
    computed: {
        generationHeader() {
            return {
                ...(this.cbtheaderitem || {}),
                questionHeaderId: Number(this.QuestionHeaderIdval)
            };
        },
        searchedResultQuery() {
            if (this.searchval) {
                return this.cbtquestionitem.filter((item) => {
                    return this.searchval
                        .toLowerCase()
                        .split(" ")
                        .every(
                            (v) =>
                                (item.examQuestion || '').toLowerCase().includes(v) ||
                                (item.optionA || '').toLowerCase().includes(v) ||
                                (item.optionB || '').toLowerCase().includes(v) ||
                                (item.optionC || '').toLowerCase().includes(v) ||
                                (item.optionD || '').toLowerCase().includes(v) ||
                                (item.answerDetails || '').toLowerCase().includes(v)
                        );
                });
            } else {
                return this.cbtquestionitem;
            }
        },
    },
    methods: {
        serverQuestionId(item) {
            return Number(item.SchoolQuestionId || item.schoolQuestionId || item.questionId || item.QuestionId || item.Id || item.id) || 0;
        },
        questionBackendId(record) {
            const data = record.data || {};
            const payload = record.payload || {};
            return this.serverQuestionId({
                SchoolQuestionId: data.SchoolQuestionId || payload.SchoolQuestionId,
                questionId: data.questionId || payload.questionId,
                QuestionId: data.QuestionId || payload.QuestionId,
                Id: record.backendId || payload.Id
            }) || null;
        },
        async removeDuplicateQuestions(db) {
            const collection = getCollection(db, 'cbtquestions');
            const docs = await collection.find({
                selector: { ownerId: getCurrentUserScope(), entityKey: `header:${Number(this.QuestionHeaderIdval) || this.QuestionHeaderIdval}` }
            }).exec();
            const groups = {};
            docs.forEach(doc => {
                const record = doc.toJSON();
                const backendId = this.questionBackendId(record);
                if (backendId) {
                    const key = String(backendId);
                    groups[key] = groups[key] || [];
                    groups[key].push(doc);
                }
            });

            for (const group of Object.values(groups)) {
                if (group.length < 2) continue;
                group.sort((left, right) => {
                    const leftRecord = left.toJSON();
                    const rightRecord = right.toJSON();
                    const active = ['pending', 'syncing', 'failed'];
                    const statusDifference = active.includes(rightRecord.syncStatus) - active.includes(leftRecord.syncStatus);
                    if (statusDifference) return statusDifference;
                    return (rightRecord.updatedAt || '').localeCompare(leftRecord.updatedAt || '');
                });
                for (const duplicate of group.slice(1)) {
                    await duplicate.remove();
                }
            }
        },
        async loadLocalQuestions() {
            const db = await getDB();
            const collection = getCollection(db, 'cbtquestions');
            await this.removeDuplicateQuestions(db);
            const docs = await collection.find({
                selector: { ownerId: getCurrentUserScope(), entityKey: `header:${Number(this.QuestionHeaderIdval) || this.QuestionHeaderIdval}` }
            }).exec();
            this.cbtquestionitem = docs.sort((left, right) =>
                left.toJSON().updatedAt.localeCompare(right.toJSON().updatedAt)
            ).map(doc => {
                const record = doc.toJSON();
                const data = record.data || {};
                return {
                    ...data,
                    examQuestion: data.examQuestion || data.ExamQuestion || '',
                    answerDetails: data.answerDetails || data.AnswerDetails || '',
                    optionA: data.optionA || data.OptionA || '',
                    optionB: data.optionB || data.OptionB || '',
                    optionC: data.optionC || data.OptionC || '',
                    optionD: data.optionD || data.OptionD || '',
                    Id: record.id,
                    syncStatus: record.syncStatus,
                    syncError: record.syncError
                };
            }).filter(item => !item._deleted);
        },
        async clearRemoteQuestionCache(db) {
            if (typeof navigator !== 'undefined' && navigator.onLine === false) return;
            const collection = getCollection(db, 'cbtquestions');
            const docs = await collection.find({
                selector: { ownerId: getCurrentUserScope(), entityKey: `header:${Number(this.QuestionHeaderIdval) || this.QuestionHeaderIdval}` }
            }).exec();
            await Promise.all(docs.map(doc => {
                const status = doc.toJSON().syncStatus;
                return ['pending', 'syncing', 'failed'].includes(status) ? null : doc.remove();
            }));
        },
        questionRecord(payload, operation, existingId) {
            const id = existingId || scopedQuestionId(this.QuestionHeaderIdval, `${Date.now()}-${Math.random().toString(36).slice(2)}`);
            const questionId = this.serverQuestionId(payload);
            const questionHeaderId = Number(payload.QuestionHeaderId || payload.questionHeaderId) || Number(this.QuestionHeaderIdval);
            const apiPayload = {
                ...(operation === 'update' ? { questionId } : {}),
                ...(operation === 'update' ? { questionHeaderId } : { questionHeaderId }),
                optionAId: Number(payload.OptionAId || payload.optionAId) || 0,
                optionBId: Number(payload.OptionBId || payload.optionBId) || 0,
                optionCId: Number(payload.OptionCId || payload.optionCId) || 0,
                optionDId: Number(payload.OptionDId || payload.optionDId) || 0,
                examQuestion: payload.ExamQuestion || payload.examQuestion || '',
                answerDetails: payload.AnswerDetails || payload.answerDetails || '',
                optionA: payload.OptionA || payload.optionA || '',
                isOptionAAnswer: payload.IsOptionAAnswer === true || payload.isOptionAAnswer === true,
                optionB: payload.OptionB || payload.optionB || '',
                isOptionBAnswer: payload.IsOptionBAnswer === true || payload.isOptionBAnswer === true,
                optionC: payload.OptionC || payload.optionC || '',
                isOptionCAnswer: payload.IsOptionCAnswer === true || payload.isOptionCAnswer === true,
                optionD: payload.OptionD || payload.optionD || '',
                isOptionDAnswer: payload.IsOptionDAnswer === true || payload.isOptionDAnswer === true
            };
            return {
                id,
                entityKey: `header:${this.QuestionHeaderIdval}`,
                backendId: questionId || null,
                data: {
                    examQuestion: payload.ExamQuestion || '',
                    answerDetails: payload.AnswerDetails || '',
                    optionA: payload.OptionA || '',
                    optionB: payload.OptionB || '',
                    optionC: payload.OptionC || '',
                    optionD: payload.OptionD || '',
                    isOptionAAnswer: payload.IsOptionAAnswer === true,
                    isOptionBAnswer: payload.IsOptionBAnswer === true,
                    isOptionCAnswer: payload.IsOptionCAnswer === true,
                    isOptionDAnswer: payload.IsOptionDAnswer === true,
                    optionAId: payload.OptionAId || 0,
                    optionBId: payload.OptionBId || 0,
                    optionCId: payload.OptionCId || 0,
                    optionDId: payload.OptionDId || 0,
                    questionId,
                    SchoolQuestionId: questionId,
                    Id: id
                },
                payload: { ...apiPayload, ClientRequestId: id },
                operation
            };
        },
        syncIcon(item) {
            return {
                pending: 'fa fa-cloud-upload-alt',
                syncing: 'fa fa-refresh fa-spin',
                synced: 'fa fa-check-circle',
                failed: 'fa fa-exclamation-circle'
            }[item.syncStatus] || 'fa fa-cloud';
        },
        syncTitle(item) {
            return item.syncStatus === 'failed' ? 'Retry synchronization' : `Synchronization ${item.syncStatus}`;
        },
        syncQuestionRecord(current) {
            const questionId = Number(
                current.backendId ||
                current.payload && (current.payload.questionId || current.payload.SchoolQuestionId || current.payload.QuestionId) ||
                current.data && (current.data.SchoolQuestionId || current.data.questionId || current.data.QuestionId)
            ) || 0;
            const payload = {
                ...(current.payload || {}),
                ...(current.operation === 'update' || questionId ? { questionId } : {}),
                questionHeaderId: Number(current.payload && (current.payload.questionHeaderId || current.payload.QuestionHeaderId)) || Number(this.QuestionHeaderIdval),
                optionAId: Number(current.payload && (current.payload.optionAId || current.payload.OptionAId)) || 0,
                optionBId: Number(current.payload && (current.payload.optionBId || current.payload.OptionBId)) || 0,
                optionCId: Number(current.payload && (current.payload.optionCId || current.payload.OptionCId)) || 0,
                optionDId: Number(current.payload && (current.payload.optionDId || current.payload.OptionDId)) || 0,
                examQuestion: current.payload && (current.payload.examQuestion || current.payload.ExamQuestion) || '',
                answerDetails: current.payload && (current.payload.answerDetails || current.payload.AnswerDetails) || '',
                optionA: current.payload && (current.payload.optionA || current.payload.OptionA) || '',
                isOptionAAnswer: current.payload && (current.payload.isOptionAAnswer === true || current.payload.IsOptionAAnswer === true),
                optionB: current.payload && (current.payload.optionB || current.payload.OptionB) || '',
                isOptionBAnswer: current.payload && (current.payload.isOptionBAnswer === true || current.payload.IsOptionBAnswer === true),
                optionC: current.payload && (current.payload.optionC || current.payload.OptionC) || '',
                isOptionCAnswer: current.payload && (current.payload.isOptionCAnswer === true || current.payload.IsOptionCAnswer === true),
                optionD: current.payload && (current.payload.optionD || current.payload.OptionD) || '',
                isOptionDAnswer: current.payload && (current.payload.isOptionDAnswer === true || current.payload.IsOptionDAnswer === true)
            };
            const action = current.operation === 'delete'
                ? 'deleteschquestion'
                : questionId
                    ? 'SchoolQuestion/UpdateSchoolQuestion'
                    : 'SchoolQuestion/CreateSchoolQuestion';
            if (action === 'SchoolQuestion/UpdateSchoolQuestion' && !questionId) {
                return Promise.reject(new Error('Cannot update a CBT question without QuestionId'));
            }
            return store.dispatch(action, action === 'deleteschquestion' ? current.payload : payload);
        },
        async retryQuestion(item) {
            if (item.syncStatus !== 'failed') return;
            const db = await getDB();
            const collection = getCollection(db, 'cbtquestions');
            const doc = await collection.findOne(item.Id).exec();
            if (doc) {
                await queueRecord('cbtquestions', doc.toJSON());
                await syncCollection('cbtquestions', current => this.syncQuestionRecord(current));
                await this.loadLocalQuestions();
            }
        },
        checkcheck(selectedOption) {
            if (selectedOption === 'A' && this.IsAnswerAval) {
                this.IsAnswerBval = false;
                this.IsAnswerCval = false;
                this.IsAnswerDval = false;
            } else if (selectedOption === 'B' && this.IsAnswerBval) {
                this.IsAnswerAval = false;
                this.IsAnswerCval = false;
                this.IsAnswerDval = false;
            } else if (selectedOption === 'C' && this.IsAnswerCval) {
                this.IsAnswerAval = false;
                this.IsAnswerBval = false;
                this.IsAnswerDval = false;
            } else if (selectedOption === 'D' && this.IsAnswerDval) {
                this.IsAnswerAval = false;
                this.IsAnswerBval = false;
                this.IsAnswerCval = false;
            }
        },
        openNew() {
            this.ExamQuestionval = "";
            this.AnswerDetailsval = "";
            this.ImagePathval = null;
            this.uploadedimage = null;
            this.OptionAval = "";
            this.OptionBval = "";
            this.OptionCval = "";
            this.OptionDval = "";
            this.IsAnswerAval = false;
            this.IsAnswerBval = false;
            this.IsAnswerCval = false;
            this.IsAnswerDval = false;
            this.isModified = false;
            this.modals.questionModal = true;
        },
        resetForm() {
            this.ExamQuestionval = "";
            this.AnswerDetailsval = "";
            this.OptionBval = "";
            this.OptionCval = "";
            this.OptionDval = "";
            this.IsAnswerAval = false;
            this.IsAnswerBval = false;
            this.IsAnswerCval = false;
            this.IsAnswerDval = false;
            this.isModified = false;
            this.modals.questionModal = false;
        },
        sharequestion(Id) {
            localStorage.setItem("QuestionId", Id);
            this.$router.push("/school/share-exam-question-setup");
        },
        edititem(item) {
            this.QuestionIdval = this.serverQuestionId(item);
            this.ExamQuestionval = item.examQuestion;
            this.AnswerDetailsval = item.answerDetails;
            this.ImagePathval = item.imagePath;
            this.OptionAval = item.optionA;
            this.OptionBval = item.optionB;
            this.OptionCval = item.optionC;
            this.OptionDval = item.optionD;
            this.IsAnswerAval = item.isOptionAAnswer;
            this.IsAnswerBval = item.isOptionBAnswer;
            this.IsAnswerCval = item.isOptionCAnswer;
            this.IsAnswerDval = item.isOptionDAnswer;
            this.OptionAIdval = item.optionAId;
            this.OptionBIdval = item.optionBId;
            this.OptionCIdval = item.optionCId;
            this.OptionDIdval = item.optionDId;
            this.isModified = true;
            this.modals.questionModal = true;
        },
        async submitdata() {
            let QuestionId = this.QuestionIdval;
            let QuestionHeaderId = this.QuestionHeaderIdval;
            let ExamQuestion = this.ExamQuestionval;
            let AnswerDetails = this.AnswerDetailsval;
            let OptionAId = this.OptionAIdval;
            let OptionBId = this.OptionBIdval;
            let OptionCId = this.OptionCIdval;
            let OptionDId = this.OptionDIdval;
            let OptionA = this.OptionAval;
            let OptionB = this.OptionBval;
            let OptionC = this.OptionCval;
            let OptionD = this.OptionDval;
            let IsOptionAAnswer = this.IsAnswerAval;
            let IsOptionBAnswer = this.IsAnswerBval;
            let IsOptionCAnswer = this.IsAnswerCval;
            let IsOptionDAnswer = this.IsAnswerDval;
            let userdata = {};
            if (this.isModified == false) {
                userdata = {
                    QuestionHeaderId,
                    ExamQuestion,
                    AnswerDetails,
                    OptionA,
                    IsOptionAAnswer,
                    OptionB,
                    IsOptionBAnswer,
                    OptionC,
                    IsOptionCAnswer,
                    OptionD,
                    IsOptionDAnswer
                }
            } else {
                userdata = {
                    QuestionId,
                    QuestionHeaderId,
                    ExamQuestion,
                    AnswerDetails,
                    OptionAId,
                    OptionBId,
                    OptionCId,
                    OptionDId,
                    OptionA,
                    IsOptionAAnswer,
                    OptionB,
                    IsOptionBAnswer,
                    OptionC,
                    IsOptionCAnswer,
                    OptionD,
                    IsOptionDAnswer
                }
            }

            const record = this.questionRecord(userdata, this.isModified ? 'update' : 'create', this.isModified ? scopedQuestionId(this.QuestionHeaderIdval, QuestionId) : null);
            await queueRecord('cbtquestions', record);
            await this.loadLocalQuestions();
            this.resetForm();
            this.modals.questionModal = false;
            this.ShowAlertSuccess('Saved locally. Synchronizing in the background.', '');
            syncCollection('cbtquestions', current => this.syncQuestionRecord(current));
        },
        escapeGeneratedHtml(value) {
            return String(value || '')
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;')
                .replace(/\r?\n/g, '<br>');
        },
        normalizeQuestionText(value) {
            return String(value || '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;/gi, ' ')
                .replace(/\s+/g, ' ').trim().toLocaleLowerCase().replace(/[^a-z0-9]+/g, ' ');
        },
        async saveGeneratedQuestions(questions) {
            if (!Array.isArray(questions) || !questions.length || !this.QuestionHeaderIdval) return;
            const knownQuestions = new Set(this.cbtquestionitem.map(item => this.normalizeQuestionText(item.examQuestion)));
            const unseenQuestions = [];
            questions.forEach(question => {
                const key = this.normalizeQuestionText(question.ExamQuestion);
                if (key && !knownQuestions.has(key)) {
                    knownQuestions.add(key);
                    unseenQuestions.push(question);
                }
            });
            if (!unseenQuestions.length) {
                this.ShowAlertWarning('These questions are already in the question bank. Edit the repeated wording before adding them.', '');
                return;
            }
            if (unseenQuestions.length < questions.length) {
                this.ShowAlertWarning('Repeated questions were skipped. The remaining questions were added.', '');
            }
            try {
                for (const question of unseenQuestions) {
                    const payload = {
                        QuestionHeaderId: this.QuestionHeaderIdval,
                        ExamQuestion: this.escapeGeneratedHtml(question.ExamQuestion),
                        AnswerDetails: this.escapeGeneratedHtml(question.AnswerDetails),
                        OptionA: this.escapeGeneratedHtml(question.OptionA),
                        OptionB: this.escapeGeneratedHtml(question.OptionB),
                        OptionC: this.escapeGeneratedHtml(question.OptionC),
                        OptionD: this.escapeGeneratedHtml(question.OptionD),
                        IsOptionAAnswer: question.IsOptionAAnswer === true,
                        IsOptionBAnswer: question.IsOptionBAnswer === true,
                        IsOptionCAnswer: question.IsOptionCAnswer === true,
                        IsOptionDAnswer: question.IsOptionDAnswer === true
                    };
                    await queueRecord('cbtquestions', this.questionRecord(payload, 'create'));
                }
                await this.loadLocalQuestions();
                this.modals.aiGenerator = false;
                this.ShowAlertSuccess(`${unseenQuestions.length} AI-generated question${unseenQuestions.length === 1 ? '' : 's'} saved locally and queued to synchronize.`, '');
                syncCollection('cbtquestions', current => this.syncQuestionRecord(current));
            } catch (error) {
                // Some records may already have been queued before the failure.
                // Refresh the local list so the generator can safely resubmit;
                // saveGeneratedQuestions will skip those successful records.
                await this.loadLocalQuestions();
                this.ShowAlertError(error.message || 'The generated questions could not be saved.', '');
            }
        },
        async GetSchoolQuestions() {
            const questionHeaderId = Number(this.QuestionHeaderIdval);
            if (questionHeaderId > 0) {
                const db = await getDB();
                await this.clearRemoteQuestionCache(db);
                await this.loadLocalQuestions();
                this.$store
                    .dispatch("SchoolQuestion/GetSchoolQuestions", questionHeaderId)
                    .then((resp) => {
                        if (resp.responseCode == "00") {
                            this.persistRemoteQuestions(resp.data).catch(() => {
                                this.cbtquestionitem = this.normalizeQuestionItems(resp.data);
                            });
                        }
                    })
                    .catch(() => {
                        this.loadLocalQuestions();
                    });
            }
        },
        normalizeQuestionItems(items) {
            return (items || []).map(item => ({
                ...item,
                examQuestion: item.examQuestion || item.ExamQuestion || '',
                answerDetails: item.answerDetails || item.AnswerDetails || '',
                optionA: item.optionA || item.OptionA || '',
                optionB: item.optionB || item.OptionB || '',
                optionC: item.optionC || item.OptionC || '',
                optionD: item.optionD || item.OptionD || '',
                syncStatus: item.syncStatus || 'synced'
            }));
        },
        async persistRemoteQuestions(items) {
            const db = await getDB();
            const collection = getCollection(db, 'cbtquestions');
            const uniqueItems = [];
            const seenIds = new Set();
            (items || []).forEach(item => {
                const questionId = this.serverQuestionId(item);
                if (!questionId || seenIds.has(questionId)) return;
                seenIds.add(questionId);
                uniqueItems.push(item);
            });
            await Promise.all(uniqueItems.map(async item => {
                const questionId = this.serverQuestionId(item);
                const id = scopedQuestionId(this.QuestionHeaderIdval, questionId);
                const existing = await collection.findOne(id).exec();
                if (existing && ['pending', 'syncing', 'failed'].includes(existing.toJSON().syncStatus)) return;
                if (existing && existing.toJSON().data && existing.toJSON().data._deleted) return;
                return collection.upsert({
                    id,
                    ownerId: getCurrentUserScope(),
                    entityKey: `header:${this.QuestionHeaderIdval}`,
                    data: {
                        ...item,
                        questionId,
                        SchoolQuestionId: questionId
                    },
                    payload: {
                        ...item,
                        QuestionId: questionId,
                        SchoolQuestionId: questionId
                    },
                    operation: 'update',
                    backendId: questionId,
                    syncStatus: 'synced',
                    syncError: null,
                    syncAttempts: 0,
                    lastSyncAttempt: null,
                    nextRetryAt: null,
                    lastSyncedAt: new Date().toISOString(),
                    clientUpdatedAt: new Date().toISOString(),
                    updatedAt: new Date().toISOString()
                });
            }));
            await this.removeDuplicateQuestions(db);
            await this.loadLocalQuestions();
        },
        async deleteschquestion(item) {
            const QuestionId = this.serverQuestionId(item);
            let HeaderId = this.QuestionHeaderIdval;
            if (HeaderId > 0) {
                const db = await getDB();
                const collection = getCollection(db, 'cbtquestions');
                const id = item.Id || scopedQuestionId(HeaderId, QuestionId);
                const doc = await collection.findOne(id).exec();
                if (doc) {
                    if (!QuestionId) {
                        await doc.remove();
                        await this.loadLocalQuestions();
                        this.ShowAlertSuccess('Deleted locally.', '');
                        return;
                    }
                    const current = doc.toJSON();
                    await doc.atomicPatch({
                        data: { ...(current.data || {}), _deleted: true },
                        payload: { QuestionId, HeaderId, ClientRequestId: id },
                        operation: 'delete',
                        syncStatus: 'pending',
                        syncError: null,
                        updatedAt: new Date().toISOString()
                    });
                }
                await this.loadLocalQuestions();
                this.ShowAlertSuccess('Deleted locally. Synchronizing in the background.', '');
                syncCollection('cbtquestions', current => this.syncQuestionRecord(current));
            }
        },
        GetByIdSchoolQuestionHeader() {
            let questionHeaderId = this.QuestionHeaderIdval;
            if (questionHeaderId != null) {
                this.onloader = "flex";
                this.$store
                    .dispatch("SchoolQuestion/GetByIdSchoolQuestionHeader", questionHeaderId)
                    .then((resp) => {
                        if (resp.responseCode == "00") {
                            this.cbtheaderitem = resp.data;
                        }
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            } else {
                this.$store.dispatch("logout");
                this.$router.push("/login");
            }
        },
    },
    mounted() {
        this.accessDetails = this.$store.getters['auth/_user'];
        if (this.accessDetails.isSchoolStaff == false) {
            this.$store.dispatch("auth/Logout");
            this.$router.push("/login");
        } else {
            if (this.$store.state.schooldata.schoolinfo.StatusId == 10) {
                this.$router.push("/tccbtheader");
            } else {
                this.GetByIdSchoolQuestionHeader();
                this.GetSchoolQuestions();
            }
        }

    },
    async created() {
        await getDB();
        registerSyncQueue('cbtquestions', current => this.syncQuestionRecord(current));
        await this.loadLocalQuestions();
    },
};
</script>

<style></style>
